<script setup>
defineProps({
  label: {
    type: String,
    required: true,
  },
  icon: {
    type: String,
    default: 'i-lucide-plus',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  variant: {
    type: String,
    default: 'positive',
  },
});

defineOptions({
  inheritAttrs: false,
});

const variantClassMap = {
  positive:
    'border-[#25d366]/35 bg-[#25d366]/5 text-[#128c7e] hover:bg-[#25d366]/10',
  muted: 'border-black/10 bg-n-slate-1 text-n-slate-11 hover:bg-n-slate-2',
};
</script>

<template>
  <button
    type="button"
    class="flex w-full items-center justify-center rounded-xl border border-dashed text-[11px] font-medium transition disabled:cursor-not-allowed disabled:border-black/10 disabled:bg-n-slate-1 disabled:text-n-slate-9"
    :class="variantClassMap[variant] || variantClassMap.positive"
    :disabled="disabled"
    v-bind="$attrs"
  >
    <i class="me-1 size-[15px]" :class="[icon]" />
    {{ label }}
  </button>
</template>
